import { useRouter } from 'next/router';
import { IntentItem, PageTypeEnum } from 'types';
import { buildSlugUrl, trackManually } from 'helpers';
import {
  TRACKING_SCREEN_MAPPING,
  BRAND_PAGE,
  MASTER_CATEGORY_PAGE,
  SELLER_PAGE,
} from '../constants';

export const useSearchIntent = () => {
  const router = useRouter();

  const handleClickIntentItem = (
    option: IntentItem,
    index: number,
    actionRouter: 'push' | 'replace' = 'push',
  ) => {
    let url = null;
    let targetScreen = null;
    switch (option.type) {
      case PageTypeEnum.BRAND:
        url = {
          pathname: BRAND_PAGE,
          query: {
            brandId: option.id,
          },
        };
        targetScreen = TRACKING_SCREEN_MAPPING[BRAND_PAGE];
        break;
      case PageTypeEnum.CATEGORY:
        url = {
          pathname: MASTER_CATEGORY_PAGE,
          query: {
            categoryId: option.id,
          },
        };
        targetScreen = TRACKING_SCREEN_MAPPING[MASTER_CATEGORY_PAGE];
        break;
      case PageTypeEnum.SELLER:
        url = {
          pathname: SELLER_PAGE,
          query: {
            sellerId: option.id,
          },
        };
        targetScreen = TRACKING_SCREEN_MAPPING[SELLER_PAGE];
        break;
      default:
        return;
    }
    if (!url) return;
    const href = buildSlugUrl(option.type, option.text, option.id);
    const trackingPayload = {
      screenName: 'searchProductResult',
      index,
      href,
    };
    trackManually(
      option.text,
      'searchIntent',
      targetScreen,
      JSON.stringify(trackingPayload),
    );
    router[actionRouter](url, href, { shallow: true });
  };

  return {
    handleClickIntentItem,
  };
};
